import { useEffect, useState } from "react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { COMPANY } from "@/constants/company";

// Pulsante WhatsApp fisso, visibile solo sotto 768px.
// Si nasconde quando le sezioni con elementi cliccabili (#contatti, #faq)
// sono in vista, per non coprire il pulsante di invio o altri link.
export default function WhatsAppFab() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const els = ["[data-testid='hero-section']", "#contatti", "#faq"]
      .map((s) => document.querySelector(s))
      .filter(Boolean);
    if (!els.length) return;
    const visible = new Set();
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) visible.add(e.target);
          else visible.delete(e.target);
        });
        setHidden(visible.size > 0);
      },
      { threshold: 0 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <a
      href={COMPANY.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      data-testid="whatsapp-fab"
      className={`md:hidden fixed bottom-5 right-5 z-40 flex items-center justify-center h-14 w-14 rounded-full shadow-lg ${
        hidden ? "hidden" : ""
      }`}
      style={{ backgroundColor: "#25D366" }}
    >
      <WhatsAppIcon className="h-7 w-7 text-white" />
    </a>
  );
}
